import React from 'react';
import { BookOpenIcon, KeyRoundIcon, LayoutDashboardIcon, WalletIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import type { NavGroup } from './OperatorShell';
import { Badge } from '../ui/Badge';
import { authorEarnings, authorProfile } from '../../data/author';
import { naira } from '../../utils/format';
const GROUPS: NavGroup[] = [{
  label: 'Knowledge marketplace',
  items: [{
    to: '/author',
    label: 'Needs you today',
    icon: LayoutDashboardIcon,
    end: true
  }, {
    to: '/author/titles',
    label: 'Titles and licences',
    icon: BookOpenIcon
  }, {
    to: '/author/entitlements',
    label: 'Entitlements',
    icon: KeyRoundIcon
  }]
}, {
  label: 'Money',
  items: [{
    to: '/author/earnings',
    label: 'Earnings and payouts',
    icon: WalletIcon
  }]
}];
export function AuthorShell() {
  return <OperatorShell consoleKey="author" consoleName="Author console" scopeLine={`${authorProfile.name} · ${authorProfile.role}`} groups={GROUPS} summary={<div data-id="element-4588" data-mp="w3bw86sskgys">
          <p className="text-caption text-ink-muted" data-id="element-4589" data-mp="w3lf7aff5nuz">Net earnings to date</p>
          <p className="cz-num mt-1 text-h4 font-semibold text-ink" data-id="element-4590" data-mp="111n4id3fujew">
            {naira(authorEarnings.netNaira)}
          </p>
          <Badge tone="warn" className="mt-2" data-id="element-4591" data-mp="15vrdt306f3j5">
            Payouts gated
          </Badge>
        </div>} data-id="element-4587" data-mp="2b95wmw1e0vd0" />;
}